import $ from 'jquery';
import { $win } from '../utils/globals';

// $('.js-nav-trigger').on('click', function(e) {
// 	e.preventDefault();

// 	$('body').toggleClass('has-nav');
// })


// function mobileNavigation () {
// 	$('.menu-item-has-children > a').on('click', function(e) {

// 		if ( !$(this).parent().hasClass('js-show') ) {
// 			e.preventDefault();

// 			$(this)
// 				.next()
// 				.slideDown()
// 				.parent()
// 				.addClass('js-show')
// 				.siblings()
// 				.removeClass('js-show')
// 				.find('.nav__dd')
// 				.slideUp()
// 				.find('.js-show')
// 				.removeClass('js-show');
// 		}
// 	});
// }

// if ($win.width() < 1023) {
// 	mobileNavigation();
// }



$(document).ready(function() {
    // Toggle navigation visibility on nav trigger click
    $('.js-nav-trigger').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('has-nav');
    });

    // Function to handle mobile navigation interactions
    function mobileNavigation() {
        $('.menu-item-has-children > a').on('click', function(e) {
            if (!$(this).parent().hasClass('js-show')) {
                e.preventDefault();

                $(this)
                    .next()
                    .slideDown()
                    .parent()
                    .addClass('js-show')
                    .siblings()
                    .removeClass('js-show')
                    .find('.nav__dd')
                    .slideUp()
                    .find('.js-show')
                    .removeClass('js-show');
            }
        });
    }

    // Function to initialize or destroy mobile navigation based on window width
    function initMobileNavigation() {
        if ($(window).width() < 1023) {
            mobileNavigation();
        } else {
            // Remove event listeners to prevent conflicts when switching between desktop and mobile
            $('.menu-item-has-children > a').off('click');
            $('.menu-item-has-children .nav__dd').removeAttr('style');
            $('.menu-item-has-children').removeClass('js-show');
        }
    }

    // Initialize mobile navigation on document ready
    initMobileNavigation();

    // Reinitialize mobile navigation on window resize
    $(window).resize(function() {
        initMobileNavigation();
    });
});
